import { render, staticRenderFns } from "./VuexplosiveModal.vue?vue&type=template&id=1053021e&scoped=true&"
import script from "./VuexplosiveModal.vue?vue&type=script&lang=js&"
export * from "./VuexplosiveModal.vue?vue&type=script&lang=js&"
import style0 from "./VuexplosiveModal.vue?vue&type=style&index=0&id=1053021e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1053021e",
  null
  
)

export default component.exports